import React, { useState } from "react";

import { Search } from "app/shared/antd/search";
import { useIntl } from "react-intl";

interface TableSearchProps {
  onSearch: (searchString: string) => void;
  onReset: () => void;
}


export const TableSearch = ({ onSearch, onReset }: TableSearchProps) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const intl = useIntl();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    if (e.target.value === "" && onReset) {
      onReset();
    }
  };


  const handleSearch = (value: string) => {
    onSearch(value.trim());
  };

  return (
    <div>
      <Search
        className="search-input"
        placeholder={intl.formatMessage({ id: "search" })}
        value={searchValue}
        onChange={handleChange}
        onSearch={handleSearch}
        allowClear
        autoComplete="off"
      />
    </div>
  );
};
